import { atom } from 'jotai';
import { Product_Sub_Family_Name_Enum } from '@kheops/graphql';
import { AvailabilityFilterValues } from '../common/ProductAvailabilityFilter';

interface ProductFilters {
  productFamilies: Product_Sub_Family_Name_Enum[];
  query: string;
  page: number;
  availability: AvailabilityFilterValues;
}

export const productFiltersAtom = atom<ProductFilters>({
  productFamilies: [],
  query: '',
  page: 1,
  availability: 'ALL',
});
